import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { createRootErrorHandlers, ErrorBoundary, ErrorFallback } from "@recruiter/shared";

// Self-hosted Macan (repo-bundled woff2, no external CDN), matching the buyer app: one
// Fiverr face for body/UI and headings, in four weights (300/400/600/700).
import "@recruiter/shared/tokens/fonts.css";

// Design tokens load in two tiers, in order (doctrine — see frontend/ARCHITECTURE.md):
// 1. Generated primitives + typography — MUST load first so the semantic aliases resolve.
import "@recruiter/shared/tokens/variables.css";
// 2. Semantic --rc-color-* aliases (defined against the primitive tier above).
import "@recruiter/shared/tokens.css";
// 3. App-level globals (built on the semantic tier).
import "./globals.css";

import { App } from "./App";
import { restoreReturnTo } from "./lib/return-to";

// If we just came back from Google, put the address bar back on the deep link
// the operator was signing in for (lib/return-to.ts). BEFORE `createRoot`, so
// the router reads the restored URL when it mounts and Home never flashes.
restoreReturnTo();

const root = document.getElementById("root");
if (!root) throw new Error("missing #root element");

createRoot(root, import.meta.env.PROD ? createRootErrorHandlers("admin") : undefined).render(
  <StrictMode>
    <ErrorBoundary
      fallbackRender={() => (
        <ErrorFallback
          variant="page"
          title="Something went wrong"
          message="Reload the page to try again."
          primaryAction={{ label: "Reload page", onClick: () => window.location.reload() }}
        />
      )}
    >
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
